
//4
Object.defineProperty(exports, "__esModule", { value: true });
require("wix-ui-core/index.st.css");
require("../../colors.st.css");
require("../../typography.st.css");
require("../../shadows.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "Tooltip328465666",
    {"root":"Tooltip328465666--root","right-bounce":"Tooltip328465666--right-bounce","left-bounce":"Tooltip328465666--left-bounce","top-bounce":"Tooltip328465666--top-bounce","bottom-bounce":"Tooltip328465666--bottom-bounce"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-backoffice/dist/src/components/Tooltip/Tooltip.st.css
// module id = 1272
// module chunks = 0